import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './PlayButtonOverlay.module.scss'


PlayButtonOverlay.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default function PlayButtonOverlay({ className = undefined, onClick }) {
  const handleButtonClick = (e) => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <div className={cx(styles.overlay, className)} onClick={onClick}>
      <button
        aria-label="Play video"
        type="button"
        onClick={handleButtonClick}
      >
        <FontAwesomeIcon icon="fa-solid fa-circle" />
        <FontAwesomeIcon icon="far fa-play" />
      </button>
    </div>
  )
}
